import styled from 'styled-components';

import Calendar from './Calendar';

const StyledCalendar = styled(Calendar)`
    .datepicker-popover {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 500;
        background-color: ${(props) => props.theme.colours.white};
        border: 0.1rem solid ${(props) => props.theme.colours.grey};
        border-radius: ${(props) => props.theme.corners.box.inside}px;
        display: block;
        margin-top: 1rem;
        white-space: nowrap;

        &:after {
            border: 11px solid transparent;
            border-bottom-color: ${(props) => props.theme.colours.white};
            border-top-width: 0;
            top: -11px;
        }

        &:before {
            border: 11px solid transparent;
            border-bottom-color: ${(props) => props.theme.colours.grey};
            border-top-width: 0;
            top: -12px;
        }

        &:before,
        :after {
            display: block;
            width: 0;
            height: 0;
            position: absolute;
            content: ' ';
            left: 50%;
            transform: translateX(-50%);
            transition: all 0.1s ease-in-out;
        }

        &.from {
            &:before,
            :after {
                left: 80px;
                transition: all 0.1s ease-in-out;
            }
        }

        &.to {
            &:before,
            :after {
                left: auto;
                right: 57px;
                transition: all 0.1s ease-in-out;
            }
        }
    }

    .datepicker-card {
        display: inline-block;
        margin-top: -1rem;
        padding: 2rem;
        vertical-align: top;
        width: 100%;
    }

    .datepicker__month {
        border-collapse: collapse;
        width: 100%;

        .datepicker-year-heading {
            font-family: 'Quicksand', sans-serif;
            font-weight: 700;
            line-height: 1.2;
            color: #919195;
            font-size: 1.3rem;
            font-weight: 400;
            letter-spacing: -0.02em;
            line-height: 1;
            padding: 0;
            position: relative;
            top: 0.666667rem;
            text-align: center;
        }

        .datepicker-month-heading {
            font-family: 'Quicksand', sans-serif;
            color: #262a31;
            margin-top: 0;
            padding-top: 0.9rem;
            padding-bottom: 0.9rem;
            margin-bottom: 0;
            font-size: 2.8rem;
            font-weight: 400;
            letter-spacing: -0.02em;
            line-height: 1.25;
            text-align: center;
        }

        .datepicker-day-heading {
            font-size: 1.3rem;
            font-weight: 400;
            line-height: 1;
            text-align: center;
            font-family: 'Quicksand', sans-serif;
            color: #262a31;
            margin-top: 0;
            padding-top: 0.9rem;
            padding-bottom: 0.9rem;
            margin-bottom: 0;
        }

        td {
            width: 14.28571%;
            font-family: 'Quicksand', sans-serif;
            font-weight: 700;
            line-height: 1.2;
            color: #262a31;
            font-size: 1.8rem;
            font-weight: 400;
            letter-spacing: -0.02em;
            line-height: 1.25;
            background-color: #fff;
            border: 0.1rem solid #d0d0d0;
            cursor: pointer;
            padding: 0.666667rem 0;
            position: relative;
            text-align: center;

            &:hover {
                background-color: #00a8e1;
                color: #fafafa;
            }

            &.between {
                background-color: ${(props) => props.theme.colours.primary};
                color: ${(props) => props.theme.colours.white};

                &:hover {
                    background-color: ${(props) => props.theme.colours.primary};
                }
            }

            &.start {
                background-color: ${(props) => props.theme.colours.primary};
                color: #fff;

                &:before {
                    display: block;
                    width: 0;
                    height: 0;
                    position: absolute;
                    border: 0.5rem solid transparent;
                    content: ' ';
                    border-left-color: #fff;
                    border-right-width: 0;
                    transform: translateY(-50%);
                    left: -0.1rem;
                    top: 50%;
                }

                &:hover {
                    background-color: #3db5e2;
                }
            }

            &.end {
                background-color: ${(props) => props.theme.colours.primary};
                color: #fff;

                &:after {
                    display: block;
                    width: 0;
                    height: 0;
                    position: absolute;
                    border: 0.5rem solid transparent;
                    content: ' ';
                    border-left-width: 0;
                    border-right-color: #fff;
                    transform: translateY(-50%);
                    right: -0.1rem;
                    top: 50%;
                }

                &:hover {
                    background-color: #00a8e1;
                }
            }

            &.past {
                cursor: not-allowed;
                opacity: 0.2;

                &:hover {
                    background-color: transparent;
                    color: #262a31;
                }
            }

            &.empty {
                background-color: transparent;
                border: 0;
                cursor: default;
                padding-top: 0;
                padding-bottom: 0;
                height: 0;

                &:hover {
                    background-color: transparent;
                }
            }
        }
    }
`;

export default StyledCalendar;
